import React from 'react'

function streamEdit() {
    return (
        <div>
            streamEdit
        </div>
    )
}

export default streamEdit
